import SortTable from './SortTable';

export default SortTable;
